import React from 'react';
import {Typography, Tag} from 'antd';

import {format, FORMAT_LONG_ALL} from '@/util/dateUtils';

const {Text} = Typography;

const columnDefines = () => ({
    taskName: {
        title: '任务名称',
        dataIndex: 'taskName',
    },
    ip: {
        title: 'IP',
        dataIndex: 'ip',
    },
    status: {
        title: '状态',
        dataIndex: 'status',
        render: text => {
            if (text === 0) return <Tag color="#2db7f5">正常</Tag>;
            else return <Tag color="red">异常</Tag>;
        },
    },
    execTime: {
        title: '执行时间',
        dataIndex: 'execTime',
        render: text => {
            return <Text>{format(text, FORMAT_LONG_ALL)}</Text>;
        },
    },
});

export function getColumns(keys) {
    return keys.map(key => columnDefines()[key]).filter(Boolean);
}
